import React, { useState, useEffect } from "react";
import FadedBackgroundLayout from '../layouts/FadedBackgroundLayout'
//import Time from "../../utils/time";
//import Link from "next/link";

const Registration = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [activationMessage, setActivationMessage] = useState("");

  const handleUsername = (e) => {
    setUsername(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(e);

    //sending data to backend api
    fetch(`${process.env.REACT_APP_API_URL}/user/register`, {
      method: "POST",
      body: JSON.stringify({
        user_name: username,
        user_email_address: email,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => {
        res.json().then((res) => {
          if (res.message === "Activation email sent") {
            setActivationMessage(res.message);
          } else {
            setError(res.msg);
          }
        });
      })
      .catch((error) => {
        setError("An error occurred during registration.");
      });
  };

  return (
    <FadedBackgroundLayout>
    <section
      id="banner-2"
      className="bg-01 wide-60 banner-section"
      style={{  marginTop: "100px" , height: "100vh", overflow: "auto" }}
    >
      <div className="container">
        <div className="row d-flex align-items-center">
          {/* BANNER TEXT */}
          <div className="col-md-7">
            <div className="banner-2-txt white-color">
              {/* Title */}
              <h3 className="h3-lg">
                <span>Welcome to Syntax Map</span>
                <br></br>
                <br></br>
                Register now <br></br>
                <span>to learn and practise English.</span>
                <br></br>
                New Beginning to TOEIC preparation.
              </h3>
              {/* COUNTDOWN ELEMENT 
              <div className="countdown">
                <span className="countdown-txt">Ends in</span>
                <div id="clock">
                  <div className="cbox clearfix">
                    <span className="cbox-digit">
                      {Time("2022-09-27 00:00:00").days}
                    </span>{" "}
                    <span className="cbox-txt">d</span>
                  </div>
                  <div className="cbox clearfix">
                    <span className="cbox-digit">
                      {Time("2022-09-27 00:00:00").hours}
                    </span>{" "}
                    <span className="cbox-txt">h</span>
                  </div>
                  <div className="cbox clearfix">
                    <span className="cbox-digit">
                      {Time("2022-09-27 00:00:00").minutes}
                    </span>{" "}
                    <span className="cbox-txt">m</span>
                  </div>
                  <div className="cbox clearfix">
                    <span className="cbox-digit">
                      {Time("2022-09-27 00:00:00").seconds}
                    </span>{" "}
                    <span className="cbox-txt">s</span>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
          {/* REGISTER FORM */}
          <div className="col-md-5">
            <div id="register-form">
              <form
                name="registerForm"
                className="row register-form"
                onSubmit={handleSubmit}
              >
                {/* Form Input */}
                <div id="input-name" className="col-md-12">
                  <p>Your Name*</p>
                  <input
                    type="text"
                    value={username}
                    autoComplete="off"
                    className="form-control name"
                    placeholder="Enter Your Name*"
                    onChange={handleUsername}
                    required
                  />
                </div>
                {/* Form Input */}
                <div id="input-email" className="col-md-12">
                  <p>Your Email*</p>
                  <input
                    type="email"
                    value={email}
                    onChange={handleEmail}
                    autoComplete="off"
                    className="form-control email"
                    placeholder="Enter Your Email*"
                    required
                  />
                </div>
                {/* Form Input */}
                <div id="input-phone" className="col-md-12">
                  <p>Your Phone Number*</p>
                  <input
                    type="tel"
                    name="phone"
                    autoComplete="off"
                    className="form-control phone"
                    placeholder="Enter Your Phone Number*"
                  />
                </div>
                {/* Form Button */}
                <div className="col-md-12 form-btn">
                  <button
                    type="submit"
                    className="btn btn-md btn-rose tra-black-hover submit"
                  >
                    Register Now
                  </button>
                  {error && <p>{error}</p>}
                  {activationMessage && (
                    <p>Please check your email for an activation message.</p>
                  )}
                </div>

                <div className="contact-box">
                  <p>If you are already registered, please Sign In instead</p>
                  {/* Button */}

                  <a href="login" className="btn btn-tra-grey rose-hover" style={{color: '#dc3545', fontWeight: 'bold', fontSize: '18px'}}>
                    Sign In
                  </a>
                </div>
                {/* Form Message */}
                <div className="col-md-12 register-form-msg text-center">
                  <span className="loading" />
                </div>
              </form>
            </div>
          </div>
          {/* END REGISTER FORM */}
        </div>
        {/* End row */}
      </div>
      {/* End container */}
    </section>
    </FadedBackgroundLayout>
  );
};

export default Registration;


